import { signalCategories } from './signal-categories';
import { signalPrefix } from './signal-prefix';
import { signalTypes } from './signal-types';
export class Signal {
    id;
    label;
    signalName;
    category;
    signalType;
    startTime;
    endTime;
    attributes;
    constructor({ id, label, attributes }) {
        this.id = id;
        this.label = label;
        this.signalName = 'base_signal';
        this.startTime = window.performance.now();
        this.attributes = attributes;
        this.category = signalCategories.UNKNOWN;
        this.signalType = signalTypes.UNKNOWN;
    }
    getCategory() {
        return this.category;
    }
    setCategory(category) {
        this.category = category;
    }
    end(attributes) {
        this.attributes = { ...this.attributes, ...attributes };
        this.endTime = window.performance.now();
    }
    prefixedSignalName() {
        return signalPrefix(this.signalName);
    }
    setSignalType(type) {
        this.signalType = type;
    }
    getSignalType() {
        return this.signalType;
    }
}
